"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRequest = void 0;
var NodeBaseRequest_1 = require("./NodeBaseRequest");
var ExchangeRequest = /** @class */ (function (_super) {
    __extends(ExchangeRequest, _super);
    function ExchangeRequest(baseUrl) {
        var _this = _super.call(this) || this;
        _this.baseUrl = baseUrl;
        return _this;
    }
    ExchangeRequest.prototype.orders = function (baseKey, quoteKey, limit) {
        return this.fetchJSON("ordersbook/" + baseKey + "/" + quoteKey + "?limit=" + (limit ? limit : ExchangeRequest.limit));
    };
    ExchangeRequest.prototype.lasttrade = function (baseKey, quoteKey) {
        return this.fetchJSON("tradesfrom/" + baseKey + "/" + quoteKey + "?limit=1");
    };
    ExchangeRequest.prototype.playOrders = function (baseKey, quoteKey) {
        return this.fetchJSON("pair/" + baseKey + "/" + quoteKey);
    };
    ExchangeRequest.prototype.tradesAll = function (baseKey, quoteKey, orderID, limit) {
        var paramOrderID = '';
        if (orderID) {
            paramOrderID = "order=" + orderID + "&";
        }
        return this.fetchJSON("tradesfrom/" + quoteKey + "/" + baseKey + "?" + paramOrderID + "limit=" + (limit ? limit : ExchangeRequest.limit));
    };
    ExchangeRequest.prototype.order = function (signature) {
        return this.fetchJSON("order/" + signature);
    };
    ExchangeRequest.limit = 50;
    return ExchangeRequest;
}(NodeBaseRequest_1.NodeBaseRequest));
exports.ExchangeRequest = ExchangeRequest;
